<div class="header-fixed menubar-pin parent-container">
    <div id="base">
        <div class="super-container">
            <div class="page-loader-container" *ngIf="isPageLoading">
                <app-new-loader></app-new-loader>
            </div>
            <section *ngIf="!isPageLoading">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="text-primary page-heading">
                            {{'eventCategoryHeading' | translate}}
                        </h2>
                    </div>

                </div>
                <div class="section-body">
                    <div class="content-container">
                        <div class="tab-pane active">
                            <div class="header-button-container">
                                <button (click)="openPopup()">
                                    <span>
                                        <img src="../../assets/img/Add.png" alt="add">
                                        {{'addBtnText' | translate}}
                                    </span>
                                </button>
                            </div>
                            <div class="data-list-container">
                                <div *ngIf="eventCategoryData && (eventCategoryData).length > 0; else noData">
                                    <div class="data-list" *ngFor="let data of eventCategoryData; let i = index">
                                        <div class="data-list-content">
                                            {{data.categoryName}}
                                        </div>
                                        <div class="list-button">
                                            <button class="list-btn-edit" (click)="editPopup(data)">
                                                <img src="../../assets/img/edit.png" alt="edit">
                                            </button>
                                            <button class="list-btn-delete" (click)="deletePopup(data)">
                                                <img src="../../assets/img/delete.png" alt="delete">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #noData>
                                    <div class="data-list">
                                        <div class="data-list-content text-center">
                                            {{'noDataAvailable' | translate}}
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div class="overlay" tabindex="-1" role="dialog" *ngIf="showOverlay">
    <div class="modal-dialog popup" role="document" *ngIf="isPopupVisible">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="isEditPopupVisible; else createText">
                    {{'editPopupHeadingText' | translate}}
                </h5>
                <ng-template #createText>
                    <h5 class="modal-title">
                        {{'popupHeadingText' | translate}}
                    </h5>
                </ng-template>
            </div>
            <form [formGroup]="eventCategoryForm" (ngSubmit)="onFormSubmit()">
                <div class="popup-body modal-body">
                    <div class="form-group">
                        <label for="categoryName">{{'eventCategoryName' | translate}}
                            <span class="required-param">
                                {{'requiredParam' | translate}}
                            </span>
                        </label>
                        <input type="text" id="categoryName" formControlName="eventCategoryName"
                            placeholder="{{'eventCategoryPlaceholder' | translate}}">
                        <div class="error-block">
                            <div *ngIf="eventCategoryForm.get('eventCategoryName')?.touched">
                                <small *ngIf="eventCategoryForm.get('eventCategoryName')?.hasError('required')">
                                    {{'requiredEventCategoryName' | translate}}
                                </small>
                                <small *ngIf="eventCategoryForm.get('eventCategoryName')?.hasError('minlength')">
                                    {{'minCharEventCategoryName' | translate}}
                                </small>
                                <small *ngIf="eventCategoryForm.get('eventCategoryName')?.hasError('maxlength')">
                                    {{'maxCharEventCategoryName' | translate}}
                                </small>
                                <small *ngIf="eventCategoryForm.get('eventCategoryName')?.hasError('invalidCharacter') 
                                && !eventCategoryForm.get('eventCategoryName')?.hasError('maxlength')
                                && !eventCategoryForm.get('eventCategoryName')?.hasError('minlength')
                                && !eventCategoryForm.get('eventCategoryName')?.hasError('required')">
                                    {{'pleaseProvideValueCharErrorMessage' | translate}}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{'colorCode' | translate}}
                            <span class="required-param">
                                {{'requiredParam' | translate}}
                            </span>
                        </label>
                        <div class="color-code-input-container">
                            <div class="color-selector">
                                <div *ngFor="let color of colorList" class="color-circle"
                                    [ngStyle]="{ 'background-color': color.colorCode }"
                                    [class.selected]="selectedColor === color.pkColorId"
                                    [class.disabled]="createEventFormSubmit"
                                    (click)="!createEventFormSubmit && selectColor(color.pkColorId)">
                                </div>
                            </div>
                        </div>
                        <div class="error-block">
                            <div
                                *ngIf="eventCategoryForm.get('eventCategoryColor')?.invalid && eventCategoryForm.get('eventCategoryColor')?.touched">
                                <small>
                                    {{'requiredEventCategoryColor' | translate}}
                                </small>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info" (click)="closePopup()"
                        aria-label="Close" [disabled]="createEventFormSubmit">{{'closeText' | translate}}</button>
                    <button type="submit" class="submit-btn btn btn-raised ink-reaction btn-info"
                        [disabled]="eventCategoryForm.invalid || createEventFormSubmit || eventCategoryForm.pristine">
                        <div *ngIf="createEventFormSubmit;else submitText">
                            <app-button-loader></app-button-loader>
                        </div>
                        <ng-template #submitText>
                            {{
                            isEditPopupVisible ? ('editText' | translate) : ('createText' | translate)
                            }}
                        </ng-template>
                    </button>
                </div>
            </form>
        </div>
    </div>

    <div class="modal-dialog popup" role="document" *ngIf="isDeleteConfirmBox">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{'deleteHeadingModal' | translate}}</h5>
            </div>
            <div class="popup-body modal-body text-center">
                <h4>
                    {{'deletConfirmStatement' | translate}}
                </h4>
            </div>
            <div class="modal-footer">
                <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info" (click)="closePopup()"
                    [disabled]="createEventFormSubmit" aria-label="Close">
                    {{'closeText' | translate}}
                </button>
                <button type="submit" class="submit-btn btn btn-raised ink-reaction btn-danger"
                    (click)="deleteEventCategory()" [disabled]="createEventFormSubmit">
                    <div *ngIf="createEventFormSubmit;else submitText">
                        <app-button-loader></app-button-loader>
                    </div>
                    <ng-template #submitText>
                        {{ 'deleteText' | translate }}
                    </ng-template>
                </button>
            </div>
        </div>
    </div>

    <div class="modal-dialog popup confim-delete-popup" role="document" *ngIf="confirmDeletePopup">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{'confirmDeleteHeadingModal' | translate}}</h5>
            </div>
            <div class="popup-body modal-body text-left">
                <h4>
                   {{conflictCategoryData.length}} {{ conflictCategoryData.length === 1 ? ('eventSingular' | translate): ('eventPlural' | translate) }} {{'whenEventScheduleInDeleteCategory' | translate}}
                </h4>
                <h4>
                    {{'giveDeleteEventCondition' | translate}}
                </h4>
                <h4>
                    {{ 'deletConfirmStatement' | translate }}
                </h4>
            </div>
            <div class="modal-footer">
                <button type="button" class="closed-btn btn btn-raised ink-reaction btn-info" (click)="closePopup()"
                    [disabled]="confirmDeletePopupForm" aria-label="Close">
                    {{'closeText' | translate}}
                </button>
                <button type="submit" class="submit-btn btn btn-raised ink-reaction btn-danger"
                    (click)="confirmDeleteEventCategory()" [disabled]="confirmDeletePopupForm">
                    <div *ngIf="confirmDeletePopupForm;else submitText">
                        <app-button-loader></app-button-loader>
                    </div>
                    <ng-template #submitText>
                        {{ 'deleteText' | translate }}
                    </ng-template>
                </button>
            </div>
        </div>
    </div>